import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Error", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Warning", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Notification", -1)

import { useAppContext } from '@/app/_tech';
import ModalPopup from '@/components/tech/ModalPopup.vue'

//const props = defineProps<{ message?: string }>();


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


//import { onMounted, onBeforeMount, defineProps } from 'vue'
const context = useAppContext();

const tech = context.tech;


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(ModalPopup, {
        visible: _unref(tech).error != '',
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(tech).error = '')),
        css: "popup-error"
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        body: _withCtx(() => [
          _createTextVNode(" Service is unavailable ")
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(ModalPopup, {
        visible: _unref(tech).warning != '',
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(tech).warning = '')),
        css: 'popup-warning'
      }, {
        header: _withCtx(() => [
          _hoisted_2
        ]),
        body: _withCtx(() => [
          _createTextVNode(" Your changes conflicated with other. Please review and try again to submit. ")
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(ModalPopup, {
        visible: _unref(tech).authentication != '',
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(tech).authentication = ''))
      }, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        body: _withCtx(() => [
          _createTextVNode(" You are not authenticated ")
        ]),
        _: 1
      }, 8, ["visible"])
    ])),
    _createVNode(_component_notifications, { position: "top center" })
  ], 64))
}
}

})